<template>
	<div>
		<div class="honor" v-for="item in showData()">
			<div class="tit">{{item.year}}</div>
			<div class="list">
				<ul>
					<li v-for="item2 in item.list">
						<div class="img"><img :src="item2.img"></div>
						<div style="position: relative; z-index: 88;"></div>
						<p>{{item2.title}}</p>
					</li>
				</ul>
			</div>
		</div>
		<div class="pagebox">
			<el-pagination background layout="prev, pager, next" :total="array.length" :page-size="page_size" @current-change="sizeChang"></el-pagination>
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				page_size: 2,
				page_num: 1,
				array: [{
					year: '2020',
					list: [{
						title: '售后服务认证证书',
						img: '/images/certificate/3.jpg'
					}, {
						title: '质量管理体系认证证书',
						img: '/images/certificate/5.jpg'
					}, {
						title: '北京市诚信创建企业',
						img: '/images/certificate/1.jpg'
					}]
				}, {
					year: '2019',
					list: [{
						title: '知识产权管理体系认证证书',
						img: '/images/certificate/4.jpg'
					}, {
						title: '重合同守信用企业证书',
						img: '/images/certificate/7.png'
					}, {
						title: '中关村高新技术企业',
						img: '/images/certificate/6.jpg'
					}]
				}, {
					year: '2018',
					list: [{
						title: '高新技术企业',
						img: '/images/certificate/2.jpg'
					}]
				}, {
					year: '2017',
					list: [{
						title: '软件产品证书',
						img: '/images/certificate/8.png'
					}]
				}]
			}
		},
		methods: {
			showData() {
				return this.array.slice((this.page_num - 1) * this.page_size, (this.page_num) * this.page_size)
			},
			sizeChang(e) {
				this.page_num = e
			}
		}
	}
</script>

<style scoped >
	.honor {
		background: #fff;
		padding: 40px;
		margin-bottom: 20px;
	}
	
	.tit {
		font-size: 26px;
		color: #151515;
	}
	
	.list {
		overflow: hidden;
	}
	
	ul {
		margin-left: -8px;
		margin-right: -8px;
		letter-spacing: -5px;
		padding: 0;
		box-sizing: border-box;
		-moz-box-sizing: border-box;
		/* Firefox */
		-webkit-box-sizing: border-box;
		/* Safari */
	}
	
	li {
		display: inline-block;
		vertical-align: top;
		width: 50%;
		letter-spacing: 0px;
		margin-top: 20px;
		padding: 0 10px;
		box-sizing: border-box;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
	}
	
	li img {
		max-width: 100% !important;
		max-height: 400px !important;
		display: block;
		font-size: 0px;
	}
		
	li p {
		margin-top: 15px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: 16px;
	}

	.pagebox {
		margin-top: 70px;
		text-align: center;
	}
</style>
